import {
    Assets,
    Container,
    Graphics,
} from 'pixi.js';
import * as WebFont from 'webfontloader';
import {sound} from '@pixi/sound';
import {
    SCREEN_WIDTH,
    SCREEN_HEIGHT,
    FONT_LIST,
} from './GameConst';

// TODO: ユーザー設定に変更
let bgmVolume = 0.1;

class SceneManager {
    constructor() {
        this.app = null;
        this.currentScene = null;
        this.currentBGM = null;
        this.initialized = false;
        this.isHidden = false;

        let hidden;
        let visibilityChange;
        if (typeof document.hidden !== 'undefined') {
            hidden = 'hidden';
            visibilityChange = 'visibilitychange';
        } else if (typeof document.mozHidden !== 'undefined') {
            hidden = 'mozHidden';
            visibilityChange = 'mozvisibilitychange';
        } else if (typeof document.msHidden !== 'undefined') {
            hidden = 'msHidden';
            visibilityChange = 'msvisibilitychange';
        } else if (typeof document.webkitHidden !== 'undefined') {
            hidden = 'webkitHidden';
            visibilityChange = 'webkitvisibilitychange';
        }
        if (hidden) {
            document.addEventListener(visibilityChange, () => {
                if (document[hidden]) {
                    this.isHidden = true;
                    // ポーズ突入
                    if (this.currentBGM && !this.currentBGM.paused) {
                        this.currentBGM.paused = true;
                    }
                } else {
                    this.isHidden = false;
                    if (this.currentBGM && this.currentBGM.paused) {
                        this.currentBGM.paused = false;
                    }
                }
            });
        }
    }

    async Init(app) {
        if (this.initialized) return;

        this.initialized = true;
        this.app = app;
        this.app.ticker.add((dt) => {
            this.UpdateScene(dt);
        });
        this.app.view.addEventListener('webglcontextlost', () => {
            window.location.reload();
        });
        this.viewComputedStyle = document.defaultView.getComputedStyle(this.app.view);
        this.sceneContainer = new Container();
        this.loadingContainer = new Container();
        this.app.stage.addChild(this.sceneContainer);
        this.app.stage.addChild(this.loadingContainer);
        const loadingScreen = new Graphics();
        loadingScreen.beginFill(0x000);
        loadingScreen.drawRect(0, 0, SCREEN_WIDTH, SCREEN_HEIGHT);
        loadingScreen.endFill();
        loadingScreen.eventMode = 'static';
        this.loadingContainer.addChild(loadingScreen);

        await new Promise((resolve) => {
            WebFont.load({
                google: {
                    families: FONT_LIST,
                },
                active: resolve,
                inactive: resolve,
            });
        });
    }

    async LoadScene(NextSceneClass, args) {
        if (!this.initialized) return;
        this.loadingContainer.visible = true;

        if (this.currentScene) {
            this.currentScene.destroy({children: true});
            this.currentScene = null;
        }
        const nextScene = new NextSceneClass();
        await this.LoadResources(nextScene);
        await nextScene.Init(args);
        this.currentScene = nextScene;
        this.sceneContainer.addChild(nextScene);
        if (this.currentBGM) {
            this.currentBGM.stop();
            this.currentBGM = null;
        }
        if(nextScene.bgm())
        {
            this.currentBGM = sound.play(nextScene.bgm(), {loop: true, volume: bgmVolume});
        }
        if (this.isHidden) {
            this.currentBGM.paused = true;
        }
        this.loadingContainer.visible = false;
    }

    setBGM(bgmName, loop) {
        if(!bgmName) {
            this.currentBGM.stop();
            this.currentBGM = null;
            return;
        }

        if (this.currentBGM) {
            this.currentBGM.stop();
            this.currentBGM = null;
        }
        this.currentBGM = sound.play(bgmName, {loop, volume: bgmVolume});
        if (this.isHidden) {
            this.currentBGM.paused = true;
        }
    }

    async LoadResources(nextScene) {
        const sceneResources = nextScene.resources();
        const loadResources = sceneResources.filter(
            (resource) => !Assets.cache.has(resource[0])
        );

        let needLoad = false;
        let resourceNames = [];
        loadResources.forEach((resource) => {
            Assets.add(resource[0], resource[1]);
            resourceNames.push(resource[0]);
            needLoad = true;
        });
        if (!needLoad) return;
        await Assets.load(resourceNames).then();
    }

    UpdateScene(dt) {
        if (!this.initialized) return;
        if (!this.currentScene) return;
        this.currentScene.UpdateScene(dt);
    }
}
export const sceneManager = new SceneManager();
